export const VIEW_BUDGET = 'budget';
export const VIEW_GALLERY = 'gallery';
export const VIEW_TRADE_TRACKER = 'trade-tracker';
export const VIEW_DOSSIER = 'dossier';

export const VIEW_TILES = 'tiles';
export const VIEW_DETAIL = 'detail';
